import { render, staticRenderFns } from "./lukon-termination.vue?vue&type=template&id=1dc0abb5&"
import script from "./lukon-termination.vue?vue&type=script&lang=js&"
export * from "./lukon-termination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports